<script>
  import { navigate } from "svelte-navigator";
  import { fetchReportFile, processReportFile } from 'utils';
  // import yaml from 'js-yaml';
  import { Button } from "smelte";
  import { prefilledReportContent, exportTitle, exportType } from "store";
  export let report;

  function selectReport() {
    
    let finalDoc = fetchReportFile(report.path).then(parsedDoc => 
      processReportFile(parsedDoc)
    ).then(processedDoc =>
      preFillConceptReport(processedDoc)
    ).then(
      exportType.set(report.type), 
      redirectToConceptReport()
    );
  };
  
  function preFillConceptReport(doc) {
    exportTitle.set(doc.title);
    prefilledReportContent.set(doc.report);
  };

  function redirectToConceptReport() {
    navigate("/conceptpv");
  };
</script>

<main>
  {#if report.enabled}
    <Button on:click={selectReport}>{report.title}</Button>
  {:else}
    <Button on:click={selectReport} disabled>{report.title}</Button>
  {/if}
</main>

<style>

</style>